import { useStore } from 'src/contexts/StoreContext';
import { EditLookupToolbarProps } from '../EditLookupToolbar.types';
import { useMemo } from 'react';
import { ProductOptionModel } from 'src/store/_models/productOption';
import { EDIT_TOOLS } from '../../base-toolbar/BaseToolbar.constants';
import { ACTIVE_TOOLS } from 'src/store/page-project/pageProject.constants';
import { AnalyticsEvents } from 'src/_shared/analyticsEvents';
import amplitude from 'src/_shared/amplitude';
import { getAvailableEditTool } from '../EditLookupToolbar.constants';
import { parseAnalyticsParamsByUserImageArea } from 'src/_shared/analytics.utils';

export const useAdjustmentsToolLogic = ({ onOpenTool, onCloseTool }: EditLookupToolbarProps) => {
  const {
    project: { setActiveTool, activeUserImageArea },
  } = useStore();

  return useMemo(
    () => ({
      tool: ProductOptionModel.create({
        code: EDIT_TOOLS.adjustments,
        choices: [],
      }),
      onOpenTool: async () => {
        setActiveTool(ACTIVE_TOOLS.adjustments);
        amplitude.trackEvent(
          AnalyticsEvents.modifyPhoto.adjustOptionClick,
          parseAnalyticsParamsByUserImageArea(activeUserImageArea),
        );
        return {
          canBeSelected: true,
        };
      },
      onCloseTool,
      ToolOptionsRenderer: getAvailableEditTool(EDIT_TOOLS.adjustments)?.ToolOptionsRenderer,
    }),
    [onOpenTool, onCloseTool],
  );
};
